export enum CONTENT_TYPE {
  PROGRAM = 'PROGRAM',
  COLLECTIONS = 'COLLECTIONS',
  COURSE = 'COURSE',
  MATERIALS = 'MATERIALS',
}
